import React from 'react';
import { ClipboardList, Clock, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import ApprobationsCrudShell from './ApprobationsCrudShell';
import { REQUEST_STATUS, statusBadge, defaultStats, mapRecordJsonFields } from './approbationsShared';

const NS = 'statutsApprobationsPage';
const API = '/api/approbations/requests';

const EMPTY = {
  request_code: '', title: '', status: 'en_attente', priority: 'normal', notes: '',
};

export default function StatutsApprobationsPage() {
  const statusOpts = REQUEST_STATUS.map((s) => ({ value: s.value, labelKey: s.labelKey }));

  return (
    <ApprobationsCrudShell
      ns={NS}
      icon={ClipboardList}
      apiPath={API}
      codeField="request_code"
      entityPrefixKey="approvalRequest"
      codePrefixFallback="AR"
      codeEditable={false}
      entityLabel="طلب الموافقة"
      entityLabelPlural="طلبات الموافقة"
      gradient="from-orange-500 to-orange-700"
      emptyForm={EMPTY}
      allowCreate={false}
      computeStats={(records) => defaultStats(records, {
        totalIcon: ClipboardList,
        fields: [
          { titleKey: 'stat_pending', field: 'status', value: 'en_attente', icon: Clock, color: 'from-amber-500 to-amber-600' },
          { titleKey: 'stat_in_progress', field: 'status', value: 'en_cours', icon: AlertCircle, color: 'from-blue-500 to-blue-600' },
          { titleKey: 'stat_approved', field: 'status', value: 'approuve', icon: CheckCircle, color: 'from-green-500 to-green-600' },
          { titleKey: 'stat_rejected', field: 'status', value: 'rejete', icon: XCircle, color: 'from-red-500 to-red-600' },
        ],
      })}
      columns={[
        { key: 'request_code', labelKey: 'col_code' },
        { key: 'title', labelKey: 'col_title' },
        { key: 'requester_name', labelKey: 'col_requester' },
        { key: 'current_step', labelKey: 'col_step' },
        { key: 'status', labelKey: 'col_status', render: (r, _p, _t, pl) => statusBadge(r.status, pl) },
        { key: 'updated_at', labelKey: 'col_updated' },
      ]}
      formSections={[
        {
          id: 'status',
          titleKey: 'section_status',
          fields: [
            { key: 'title', labelKey: 'field_title', readOnly: true, fullWidth: true },
            { key: 'status', labelKey: 'field_status', type: 'select', options: statusOpts },
            { key: 'notes', labelKey: 'field_notes', type: 'textarea', colSpan: 2 },
          ],
        },
      ]}
      mapRecordToForm={(r) => mapRecordJsonFields({
        request_code: r.request_code || '',
        title: r.title || '',
        status: r.status || 'en_attente',
        priority: r.priority || 'normal',
        notes: r.notes || '',
      }, EMPTY)}
      mapFormToPayload={(f, editing) => ({
        title: f.title || editing?.title,
        status: f.status,
        notes: f.notes || null,
      })}
    />
  );
}
